import { combineReducers } from 'redux';
import user from './user';
import token from './token';
import sessionId from './sessionId';

export default combineReducers({ user, token, sessionId });
